import React, { ReactElement } from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'

import {
  Box,
  ErrorMessage,
  Label,
  Flex,
  Icon,
  overlays,
} from '@mindfulchefuk/design-system'

import { CC_ERROR, CC_LOCKED } from '@mindfulchefuk/constants'

type TCardField = {
  label: string
  state: string
  frameId: string
  icon?: ReactElement
}

interface Props {
  locked: boolean
}

const disabledStyles = css`
  &:before {
    content: '';
    position: absolute;
    top: -5%;
    right: -5%;
    bottom: -5%;
    left: -5%;
    background-color: ${overlays['white.50']};
  }
`
const InputContainer = styled(Flex)<Props>`
  justify-content: flex-end;
  align-items: center;
  position: relative;

  ${(props) => props.locked && disabledStyles}
`

export const CardField = ({
  label,
  state,
  frameId,
  icon,
}: TCardField): ReactElement => {
  const fieldError = state === CC_ERROR

  return (
    <Box>
      <Label>{label}</Label>
      <InputContainer locked={state === CC_LOCKED}>
        <Box position="absolute" right="16px" display="flex">
          {fieldError ? <Icon color="tomato" type="warning" size={20} /> : icon}
        </Box>
        <Box className={frameId} h="60px" w="100%" />
      </InputContainer>
      {fieldError && <ErrorMessage>{label} is invalid</ErrorMessage>}
    </Box>
  )
}
